import { BXLoader } from '../BXLoader';

const lastWait = [];
const findRef = (refNode) => (ref) => ref.$el.parentNode === refNode;
const getNode = (node) => BX(node) || document.body || document.documentElement;

try {
BX.showWait = function (node, message) {
	node = getNode(node);
	message = message || BX.message('JS_CORE_LOADING');

	const container_id = node.id || Math.random();
	let obMsg;

	if (!node.bxmsg) {
		const loader = new BXLoader({ data: { message } });
		const root = BX.create('DIV', {
			props: { id: 'wait_' + container_id },
			style: {
				background: 'hsla(0, 0%, 100%, .7)',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				position: 'fixed',
				zIndex: '10000',
				height: '100%',
				width: '100%'
			}
		});

		loader.$mount();
		node.appendChild(root);
		root.appendChild(loader.$el);
		obMsg = node.bxmsg = loader.$el.parentNode;
		lastWait.push(loader);
	} else {
		const ref = lastWait.find(findRef(node.bxmsg));

		ref.$set({}, ref.$data, { message, awaiting: ++ref.$data.awaiting });
		obMsg = node.bxmsg;
	}

	if (node === document.body && !document.body.classList.contains('overflow-hidden'))
		document.body.classList.add('overflow-hidden');

	return obMsg;
};

BX.closeWait = function(node, obMsg) {
	node = getNode(node);

	if (node && !obMsg)
		obMsg = node.bxmsg;

	if (node && !obMsg && BX.hasClass(node, 'bx-core-waitwindow'))
		obMsg = node;

	if (node && !obMsg)
		obMsg = BX('wait_' + node.id);

	if (!obMsg && lastWait.length > 0) {
		obMsg = lastWait[lastWait.length - 1].loaderRef.parentNode;
	}

	if (!obMsg)
		return;

	const ref = lastWait.find(findRef(obMsg));

	if (ref.$data.awaiting > 1)
		ref.awaiting = --ref.awaiting;
	else {
		const refIndex = lastWait.indexOf(ref);

		lastWait.splice(refIndex, 1);
		ref.$destroy();
		obMsg.parentNode.removeChild(obMsg);

		node.bxmsg = null;
		BX.cleanNode(obMsg, true);


		if (node === document.body && document.body.classList.contains('overflow-hidden'))
			document.body.classList.remove('overflow-hidden');
	}
};
} catch (e) {
	// silent
}
